const MixpanelAdaptor = (adaptorPayload) => {

  // Creates a payload that is handled by the mixpanel client.
  // The mixpanel client may not be loaded at first, therefore it may need to initialized.
  // site-page-view may trigger before adaptor is intiailized therefore it is quequed and triggered on init.

  const proxyInfoKeysToTrack = [];

  const siteInfoKeysToTrack = [
    'page_name'
  ];

  const proxyInfoKeysToTrackOnce = [
    'proxy_id',
    'domain',
    'whitelabel_id',
    'partner_sub_id',
    'partner_proxy_id',
    'partner_proxy_category_id',
    'partner_proxy_sub_id'
  ];

  const siteInfoKeysToTrackOnce = [
    'site_id',
    'formatted_domain',
    'domain',
    'base_directory',
    'whitelabel_id',
    'theme_id',
    'partner_sub_id',
    'subdomain'
  ];

  const configure = () => {

    let mode = adaptorPayload.mode;
    client = window.mixpanel;
    window.mixpanelInit.loaded = true;
    client.set_config({cross_subdomain_cookie: false});

    if (mode === 'site') {
      client.register_once(makeSuperPropertiesOnce(siteInfoKeysToTrackOnce));
      client.register(makeSuperProperties(siteInfoKeysToTrack));
    } else if (mode === 'proxy') {
      client.register_once(makeSuperPropertiesOnce(proxyInfoKeysToTrackOnce));
      client.register(makeSuperProperties(proxyInfoKeysToTrack));
    }

    for (let event in eventQueue){
      eventQueue[event]();
    }

  }

  const makeSuperPropertiesOnce = (infoKeysToTrackOnce) => {

    let key, match, track;
    let props = {
      'initial_landing_page': window.location.href,
    };
    const ref = infoKeysToTrackOnce;

    for (let i = 0; i < ref.length; i++) {
      key = ref[i];
      if (window.sb.siteInfo[key] != null) {
        props[key] = window.sb.siteInfo[key];
      }
    }

    // get all UTM params, even non-standard ones
    let url = decodeURIComponent(document.URL);
    const regex = /[&?]([uU][tT][mM]_[^&#=]*)=([^&#]*)/g;
    while ((match = regex.exec(url)) !== null) {
      props[match[1].toLowerCase()] = match[2];
    }

    // additional marketing parameters to put into the mixpanel session if available
    // that are not added by mixpanel by default.
    //
    // common identifiers https://en.wikipedia.org/wiki/Click_identifier
    const additionalParams = [
      'dclid', // doubleclick
      'fbclid', // facebook
      'gbraid', // google
      'gclid', // google
      'gclsrc', // google
      'li_fat_id', // linkedin
      'msclkid', // microsoft/bing
      'sl_track_id', // sproutloud
      'ttclid', // tiktok
      'twclid', // twitter
      'wbraid', // google
      'yclid', // yahoo and yandex
    ];
    const params = new URLSearchParams(window.location.search);
    additionalParams.forEach((k) => {
      if (params.get(k)) {
        props[k] = params.get(k);
      }
    });

    return props;

  }

  const makeSuperProperties = (infoKeysToTrack) => {

    let props = {
      full_url: window.location.href,
      page_title: document.title,
      url: window.location.pathname,
    }

    let ref = infoKeysToTrack;

    for (let i = 0; i < ref.length; i++) {
      let key = ref[i];
      if (window.sb.siteInfo[key] != null) {
        props[key] = window.sb.siteInfo[key];
      }
    }

    return props;

  }

  const mergeProperties = (adaptorPayload) => {

    let props = adaptorPayload.publicEventExtracts;
    if (adaptorPayload.publicEventExtracts.href) {
      props.link = adaptorPayload.publicEventExtracts.href;
    } 
    
    if (adaptorPayload.analyticsEvent.category) {
      props.category = adaptorPayload.analyticsEvent.category;
    }

    return props;

  }

  // This function is not covered by tests.
  const incrementer = (property) => {

    let value = client.get_property(property);
    let update = {};
    if (value && typeof value === 'number'){
      // value++ fails to update variable before execution use ++value
      update[property] = ++value;
    } else {
      update[property] = 1;
    }
    client.register(update);

  }

  // Adaptor starts running here

  let client;
  let eventQueue = [];

  // will not run code if mixpanel is not present
  if (window.mixpanelInit) {
    if (window.mixpanelInit.loaded === true){
      configure();
    } else {
      // Bind used to replace jQuery.proxy
      // https://api.jquery.com/jQuery.proxy/
      // https://stackoverflow.com/questions/4986329/understanding-proxy-in-jquery
      // https://blog.garstasio.com/you-dont-need-jquery/utils/
      window.mixpanelInit.ready = configure.bind(this);
    }

    if (adaptorPayload.analyticsEvent.name === 'site-page-view') {
      if (window.mixpanelInit.loaded) {
        incrementer('site-session-page-views');
      } else {
        // Race condition protection
        // https://stackoverflow.com/questions/899102/how-do-i-store-javascript-functions-in-a-queue-for-them-to-be-executed-eventuall
        eventQueue.push( () => { incrementer('site-session-page-views') });
      }    
    }

    // live site behavior
    if (window.mixpanelInit.loaded) {
      return window.mixpanel.track( adaptorPayload.analyticsEvent.name, mergeProperties(adaptorPayload) );
    } else {
      eventQueue.push( () => { window.mixpanel.track( adaptorPayload.analyticsEvent.name, mergeProperties(adaptorPayload) ) })
    }
  }
}

export { MixpanelAdaptor }